import { CodeMetadataWire, CodetableMetadata } from 'app/area/indicator-factors/types-store';

export const mapMetadataToStore = (metadataWire: CodeMetadataWire): CodetableMetadata => ({

  ...(metadataWire.equipment && { equipment: !!metadataWire.equipment }),
  ...(metadataWire.location && { location: !!metadataWire.location }),
  ...(metadataWire.unit && { unit: !!metadataWire.unit }),
  ...(metadataWire.source && { source: !!metadataWire.source }),

  ...(!!metadataWire.label && {
    label: metadataWire.label
  }),

  ...(!!metadataWire.formName && {
    formName: metadataWire.formName
  }),

  ...(!!metadataWire.code && {
    codetable: metadataWire.code
  }),

  ...(!!metadataWire.category && {
    codetableCategory: metadataWire.category
  }),

  ...(!!metadataWire.class && {
    codetableClass: metadataWire.class
  }),

  ...(!!metadataWire.node && {
    codetableNode: metadataWire.node
  })
});
